import axios from 'axios'

export const TOKEN_KEY = 'auth_token'
export const TOKEN_TYPE_KEY = 'auth_token_type'

export function storeAuthToken(token: string | undefined, type: string | undefined, remember?: boolean) {
  if (!token || !type)
    return
  try {
    const storage = remember ? window.localStorage : window.sessionStorage
    storage.setItem(TOKEN_KEY, token)
    storage.setItem(TOKEN_TYPE_KEY, type)
    axios.defaults.headers.common.Authorization = `${type} ${token}`
  }
  catch {
    // ignore storage errors
  }
}

export function clearAuthToken() {
  try {
    window.localStorage.removeItem(TOKEN_KEY)
    window.localStorage.removeItem(TOKEN_TYPE_KEY)
    window.sessionStorage.removeItem(TOKEN_KEY)
    window.sessionStorage.removeItem(TOKEN_TYPE_KEY)
    delete axios.defaults.headers.common.Authorization
  }
  catch {
    // ignore
  }
}

export function getAuthToken(): { token: string | null; type: string | null } {
  try {
    const token = window.sessionStorage.getItem(TOKEN_KEY) || window.localStorage.getItem(TOKEN_KEY)
    const type = window.sessionStorage.getItem(TOKEN_TYPE_KEY) || window.localStorage.getItem(TOKEN_TYPE_KEY)
    return { token, type }
  }
  catch {
    return { token: null, type: null }
  }
}

export function getAuthHeader(): string | null {
  const { token, type } = getAuthToken()
  if (!token || !type)
    return null
  return `${type} ${token}`
}
